<form [formGroup]="specHeffingskortingenFormGroup">
    <div formGroupName="specificatieHeffingskortingen">
        <div formGroupName="opbouw">
            <div *ngFor="let propertyName of propertyNamesToCheck; let i = index">
                <div *ngIf="i === 0 || i === 1">
                    <div class="left">
                        <div class="row">
                            <div class="col col-1 pt-1">
                                <p>{{ propertyTextMap[propertyName] }}</p>
                            </div>
                            <div class="col-2">
                                <snelstart-ui-number-form-control
                                        [formControlName]="propertyName"
                                        [id]="propertyName"
                                        class="custom-input-150"
                                        [decimals]="0"
                                          prefix="€"
                                        align="right"
                                        placeholder="0"
                                        [disabledControl]=true
                                >
                                </snelstart-ui-number-form-control>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="i !== 0 && i !== 1">
                    <div class="left" *ngIf="getPropertyValue(propertyName) !== null">
                        <div class="row">
                            <div class="col col-1 pt-1">
                                <p>{{ propertyTextMap[propertyName] }}</p>
                            </div>
                            <div class="col-2">
                                <snelstart-ui-number-form-control
                                        [formControlName]="propertyName"
                                        [id]="propertyName"
                                        class="custom-input-150"
                                        [decimals]="0"
                                          prefix="€"
                                        align="right"
                                        [disabledControl]=true
                                ></snelstart-ui-number-form-control>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>

